import React from "react";
import { AdminDetailsPageItemName } from "../../../../components";
import DetailInfo from "./DetailInfo";

const ContentComponent = () => {
  return (
    <div>
      <AdminDetailsPageItemName text="Anmeldeinformationen" />
      <DetailInfo />
    </div>
  );
};

export default ContentComponent;
